import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class Centroids extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.centroid',
        group: 'Spatial Operations',
        title: 'ST Centroid',
        description: `
      This component creates a new table with a new column
      containing points representing the centroids of the original input geographies.
      `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
      case Provider.Snowflake:
      case Provider.Postgres:
      case Provider.Redshift:
        return dedent`SELECT ${connection.processOutputGeogColumn(
          `ST_CENTROID(${connection.processInputGeogColumn(
            params.geo as string
          )})`
        )} AS ${params.geo}_centroid, *
            FROM ${connection.quoteName(params.source as string)}`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40, ${
          params.geo
        }_centroid) */ ${connection.processOutputGeogColumn(
          `ST_CENTROID(${connection.processInputGeogColumn(
            params.geo as string
          )})`
        )} AS ${params.geo}_centroid, *
            FROM ${connection.quoteName(params.source as string)}`
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({
    columns,
    params,
    connection
  }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.geo}_centroid`,
      type: connection.getGeoDataType()
    })
  }
}

export { Centroids }
